import { Dialog } from '@sravni/react-design-system/lib/Dialog';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

import { SCREENS } from '../constants';
import type { AuthInlineFormProps } from '../types';
import styles from './AuthInlineForm.module.scss';
import { ConsentsScreenContentDesktop } from './ConsentsScreen';
import { OTPScreenContentDesktop } from './OTPScreen';

type Props = Pick<
    AuthInlineFormProps,
    | 'onClose'
    | 'onChangePhoneClick'
    | 'consentsScreenTitle'
    | 'advertisingBanner'
    | 'onOTPScreenOpen'
    | 'advertisingCheckboxLabel'
    | 'onChangeAgreementAdvertising'
    | 'onChangeAgreementPersonalData'
    | 'onConsentsScreenOpen'
> & {
    currentScreen: ValuesOf<typeof SCREENS>;
    setCurrentScreen: React.Dispatch<ValuesOf<typeof SCREENS>>;
    onConsentsSubmitClick?: React.MouseEventHandler<HTMLDivElement>;
    submitAttempt: number;
    isDialogVisible: boolean;
    onReturnButtonClick: () => void;
};

export const AuthInlineFormDesktopScreen = (props: Props) => {
    const {
        onClose,
        onConsentsSubmitClick,
        onChangePhoneClick,
        consentsScreenTitle,
        advertisingBanner,
        onOTPScreenOpen,
        advertisingCheckboxLabel,
        onChangeAgreementAdvertising,
        onChangeAgreementPersonalData,
        onConsentsScreenOpen,
        submitAttempt,
        isDialogVisible,
        onReturnButtonClick,
        currentScreen,
    } = props;

    const isMobile = useIsMobile();

    return (
        <Dialog visible={!isMobile && isDialogVisible} onClose={onClose} className={styles.dialog}>
            <Dialog.Content className={styles.dialogContent}>
                {currentScreen === SCREENS.OTP && (
                    <OTPScreenContentDesktop
                        onChangePhoneClick={onChangePhoneClick}
                        banner={advertisingBanner}
                        onReturnButtonClick={onReturnButtonClick}
                        onOTPScreenOpen={onOTPScreenOpen}
                    />
                )}
                {currentScreen === SCREENS.CONSENTS && (
                    <ConsentsScreenContentDesktop
                        title={consentsScreenTitle}
                        checkboxLabel={advertisingCheckboxLabel}
                        onReturnButtonClick={onReturnButtonClick}
                        onChangeAgreementAdvertising={onChangeAgreementAdvertising}
                        onChangeAgreementPersonalData={onChangeAgreementPersonalData}
                        submitAttempt={submitAttempt}
                        onConsentsScreenOpen={onConsentsScreenOpen}
                        onConsentsSubmitClick={onConsentsSubmitClick}
                    />
                )}
            </Dialog.Content>
        </Dialog>
    );
};
